import React, { useState } from "react";
import { AuthApi } from "../../services/ApiService";
import "./ForgotPasswordPage.css";

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const trimmed = email.trim();
    setMessage(
      `If an account exists for ${trimmed}, we’ve sent a password reset link. ` +
      `Please check your inbox and spam/junk folders for a message from DocuHounds.`
    );

    try {
      await AuthApi.requestPasswordReset(trimmed);
    } catch {
      // Intentionally ignored to avoid leaking account existence
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-card">
        <div className="forgot-password-brand">
          <h1>DocuHounds</h1>
        </div>
        <h2>Forgot Your Password?</h2>
        <p className="instructions">
          Enter your email address below and we'll send you a link to reset your password.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          <button type="submit" disabled={loading || !email.trim()}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        {message && (
          <p className="message" role="status" aria-live="polite">
            {message}
          </p>
        )}
      </div>
    </div>
  );
}

export default ForgotPasswordPage;